import repository from './repository'

const resource = 'stock-categories'

export default {
  index (params) {
    return repository.get(resource, { params })
  },
  store (data) {
    return repository.post(resource, data)
  },
  update (id, data) {
    return repository.put(`${resource}/${id}`, data)
  },
  attachUnits (id, data) {
    return repository.put(`${resource}/${id}/units`, data)
  },
}
